import Seo from './Seo'

/* Redux */
import Redux from './Redux'

/* Material */
import Container from '@mui/material/Container'
import Typo from '@mui/material/Typography'
import useStyles from './styles'

/* Components */
import Ausgeloggt from './Ausgeloggt'
import Eingeloggt from './Eingeloggt/Eingeloggt'
import StaticBreadcrumbs from 'src/components/Breadcrumbs/StaticBreadcrumbs'

const breadcrumb = [
  { title: 'Kundenkonto' },
]

const Kundenkonto = () => {
  const classes = useStyles()
  const { token } = Redux()

  return <Container maxWidth='lg' className={classes.container}>

    <Seo />

    <StaticBreadcrumbs items={breadcrumb} />

    <Typo component='h1' variant='h4' color='inherit' gutterBottom>
      Ihr Kundenkonto
    </Typo>

    {!token
      ? <Ausgeloggt />
      : <Eingeloggt />
    }

  </Container>
}

export default Kundenkonto
